import { render, staticRenderFns } from "./FormModals.vue?vue&type=template&id=228060a2&"
import script from "./FormModals.vue?vue&type=script&lang=ts&"
export * from "./FormModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228060a2')) {
      api.createRecord('228060a2', component.options)
    } else {
      api.reload('228060a2', component.options)
    }
    module.hot.accept("./FormModals.vue?vue&type=template&id=228060a2&", function () {
      api.rerender('228060a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Rack/FormModals.vue"
export default component.exports